export default __webpack_public_path__ + "static/media/face4.ade8a387.jpg";